module.exports = __webpack_public_path__ + "static/media/yicai.0dab4a3c.png";